
  import { defineComponent, PropType, reactive, toRefs} from "vue";
  import {OrderOperator} from "@/views/Orders/Operators/OrderOperators.vue";
  import {AsyncState} from "@/enums";
  import {init} from "@/views/Orders/Operators/OrderOperatorsComposable";

  export default defineComponent({
    name: "OrderOperatorsListQualityLevel",
    props: {
      orderUuid: {
        type: String,
        default: () => null,
      },
      editable: {
        type: Boolean,
        default: () => false
      },
      item: {
        type: Object as PropType<OrderOperator>,
        default: () => null,
      }
    },
    setup (props, context) {
      const initialState = {
        qualityLevel: props.item.qualityLevel
      };

      const {
        state: generalState,
        createOrUpdate,
        isLoading,
        isError,
        isSuccess,
        $externalResults,
      } = init();

      const state = reactive({ ...initialState });

      const update = () => {
        if (props.editable && props.item.qualityLevel != state.qualityLevel) {
          generalState.asyncState = AsyncState.LOADING;
          createOrUpdate(props.orderUuid, props.item, { qualityLevel: state.qualityLevel })
            .then(updated => {
              context.emit("updated", updated);
            })
            .catch(error => {
              $externalResults.value = {
                qualityLevel: error.response.data.title
              };
              generalState.asyncState = AsyncState.ERROR;
            });

        } else {
          generalState.asyncState = AsyncState.SUCCESS;
        }
      };

      return {
        ...toRefs(state),
        isLoading,
        isError,
        isSuccess,
        update
      };
    }
  });
